export const campaignAudienceTableHeader = [
  { title: "Name", key: "name" },
  { title: "Term", key: "termName" },
  // { title: "Field of Interest", key: "fieldOfInterest_Display" },
  { title: "Nationality", key: "nationality" },
  { title: "Last Email Received", key: "email" },
  { title: "Mobile", key: "mobile", flag: "mobile" },
  { title: "Received Date", key: "activatedOn", flag: "dateTime" },
];
